import 'leaflet/dist/leaflet.css'
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css'

import { MapContainer, TileLayer, useMap } from 'react-leaflet'
import { GestureHandling } from 'leaflet-gesture-handling'
import L from 'leaflet'
import React, { useEffect } from 'react'
import block from 'bemboo'

import LeafletMapMarker from './LeafletMapMarker'
import MarkerBlue from './markers/blue.png'
import MarkerGreen from './markers/green.png'
import MarkerBlue2X from './markers/blue-2x.png'
import MarkerGreen2X from './markers/green-2x.png'
import MarkerShadow from './markers/shadow.png'

const markerProps = {
  shadowUrl: MarkerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
}

const MarkerIcon = L.icon({
  ...markerProps,
  iconUrl: MarkerBlue,
  iconRetinaUrl: MarkerBlue2X,
})

const ActiveMarkerIcon = L.icon({
  ...markerProps,
  iconUrl: MarkerGreen,
  iconRetinaUrl: MarkerGreen2X,
})

L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling)

const FlyToBounds = ({ bounds }) => {
  const map = useMap()

  useEffect(() => {
    if (bounds && bounds.length) {
      map.flyToBounds(bounds)
    }
  }, [bounds, map])

  return null
}

const b = block('LeafletMap')

const LeafletMap = ({ center, zoom, markers = [], openActiveMarkers }) => {
  const mapProps = { center, zoom }
  if (markers.length > 1) {
    mapProps.bounds = markers.map(({ position }) => position)
  } else if (markers.length) {
    mapProps.center = markers[0].position
    mapProps.zoom = mapProps.zoom || 11
  } else {
    mapProps.center = mapProps.center || [46.7, 2.4]
    mapProps.zoom = mapProps.zoom || 11
  }
  return (
    <div className={b}>
      <MapContainer
        center={mapProps.center}
        zoom={mapProps.zoom}
        gestureHandling
      >
        {markers.map(({ id, position, title, active }) => (
          <LeafletMapMarker
            key={id || `${position}-${title}`}
            position={position}
            icon={active ? ActiveMarkerIcon : MarkerIcon}
            active={openActiveMarkers && active}
          >
            {title}
          </LeafletMapMarker>
        ))}
        <FlyToBounds bounds={mapProps.bounds} />
        <TileLayer
          attribution={
            '&copy; <a href=&quot;https://osm.org/copyright&quot;>' +
            'OpenStreetMap</a>'
          }
          url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </div>
  )
}

export default LeafletMap
